import React, { useEffect, useState, useRef } from "react";
import { errorHandler, selectIcon, SVG } from "../selector";
import "./FormInput.scss";
import * as moment from "moment";
import TimePicker from "../TimePicker/TimePicker";
import { Calenders } from "./Calender";
import { CheckWidth, CheckValue } from "../../../services/CommonFunction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import ToolTips from "../../ReusableComponents/ToolTips/ToolTips";
import CustomSelect from "../CustomSelect/CustomSelect";
import { ToggleUI } from "../Toggle/Toggle";
import Cleave from "cleave.js/react";

const inputEvent = (e, status = "", value) => {
  if (e.which === 32 && !e.target.value.length) {
    e.preventDefault();
  } else if (status === "NumberTime") {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  } else if (status === "NumberMinute") {
    if (value.length === 1) {
      if (parseInt(value) > 5) {
        // e.preventDefault();
      }
    } else if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  } else if (status === "number") {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  } else if (status === "string") {
    if (
      (e.which > 96 && e.which < 123) ||
      (e.which > 64 && e.which < 91) ||
      e.which === 32
    ) {
    } else {
      e.preventDefault();
    }
  } else if (status === "gymCode") {
    if (!e.target.value.length) {
      if ((e.which > 96 && e.which < 123) || (e.which > 64 && e.which < 91)) {
      } else {
        e.preventDefault();
      }
    } else {
      if (
        e.which > 47 ||
        e.which < 58 ||
        (e.which > 96 && e.which < 123) ||
        (e.which > 64 && e.which < 91)
      ) {
      } else {
        e.preventDefault();
      }
    }
  }
};
// const handleFeetChange = (value) => {
//   if (value.length == "2") {
//     let value = value.slice(0, 1) + "'" + value.slice(1);
//   }
//   return value;
// };
export const NumberTime = ({
  handler,
  touched,
  hasError,
  meta,
  invalid,
  valid,
  validator,
  errors,
  ...props
}) => {
  const { value } = handler();
  return (
    <React.Fragment>
      <div style={{ position: "relative", height: "47px" }}>
        <input
          readOnly={meta.readOnly || false}
          className={`formInput${
            (touched || meta.valid) && invalid ? " inputError" : ""
          }`}
          autoComplete="false"
          type="text"
          maxLength={meta.maxLength ? meta.maxLength : "2"}
          onKeyPress={(el) => inputEvent(el, meta.type || "NumberTime", value)}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
      </div>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "" : ""}
        </label>
      ) : null}
    </React.Fragment>
  );
};

export const PasswordInputs = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
}) => (
  <div>
    {meta.label !== "" ? <label>{meta.label}</label> : null}
    <div style={{ position: "relative", height: "48px" }}>
      <input
        className="formInput"
        type={meta.type}
        rows="4"
        cols="50"
        maxLength={meta.maxLength ? meta.maxLength : ""}
        onKeyPress={(el) => inputEvent(el, "text")}
        placeholder={`${meta.placeholder}`}
        {...handler()}
      />
      {/* <FontAwesomeIcon className="checkFa" style={{display:(meta['valid'] && valid)?'':'none'}} icon = { faCheck } /> */}
      {meta.valid && valid ? (
        <img className="tickIcon" src={selectIcon("verified")} alt="TICK" />
      ) : null}
    </div>
    <InputError1 meta={meta} hasError={hasError} display={touched && invalid} />
  </div>
);

export const TextInput = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  const type =
    meta.type &&
    meta.type !== "string" &&
    meta.type !== "gymCode" &&
    meta.type !== "number"
      ? meta.type
      : "text";
  // const handleFeetChange = (value) => {
  //   if (value.length == "2") {
  //     let value = value.slice(0, 1) + "'" + value.slice(1);
  //   }
  //   return value;
  // };
  return (
    <React.Fragment>
      {meta.showLabel && meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
        </label>
      ) : null}
      <div className="textInputParent">
        <SVG
          className="placeHolderIcon"
          src={selectIcon(meta.placeHolderIcon)}
        />
        {meta.feet ? (
          <Cleave
            options={{
              blocks: [1, 2],
              delimiters: ["'", '"'],
              numericOnly: true,
              numeralPositiveOnly: true,
              //prefix: '"',
              //tailPrefix: false,
            }}
            // value={`${meta.heightValue}`}
            onChange={() => console.log(meta.heightValue.length)}
            className={`formInput${touched && invalid ? " inputError" : ""}`}
            type={type}
            onKeyPress={(el) => inputEvent(el, meta.type || "text")}
            placeholder={`${meta.placeholder}`}
            {...handler()}
          />
        ) : (
          // <input
          //   className={`formInput${touched && invalid ? " inputError" : ""}`}
          //   autoComplete="false"
          //   // onChange={handleFeetChange(meta.heightValue)}
          //   // value={handleFeetChange(meta.heightValue)}
          //   type={type}
          //   maxLength={meta.maxLength ? meta.maxLength : ""}
          //   onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          //   placeholder={`${meta.placeholder}`}
          //   // {...handler()}
          // />
          <input
            className={`formInput${touched && invalid ? " inputError" : ""}`}
            autoComplete="false"
            type={type}
            maxLength={meta.maxLength ? meta.maxLength : ""}
            onKeyPress={(el) => inputEvent(el, meta.type || "text")}
            placeholder={`${meta.placeholder}`}
            {...handler()}
          />
        )}
        {meta.valid && valid ? (
          <SVG className="tickIcon" src={selectIcon("validTick")} />
        ) : null}
      </div>
      {touched && meta.showError && (
        <InputError meta={meta} hasError={hasError} />
      )}
    </React.Fragment>
  );
};

export const TextInput1 = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  validator,
  errors,
  ...props
}) => {
  const left = CheckWidth(props.value);
  const type = meta.type && meta.type !== "string" ? meta.type : "text";
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
        </label>
      ) : null}
      <div className="textInputParent">
        {meta.valid && (hasError("pattern") || hasError("duplicate")) ? (
          <img className="errorIcon" src={selectIcon("notValid")} alt="TICK" />
        ) : null}
        {meta.valid && !props.active && hasError("pattern") ? (
          <span className="errorText" style={{ left: left + "px" }}>
            (Invalid Data)
          </span>
        ) : null}
        {meta.valid && !props.active && hasError("duplicate") ? (
          <span
            className="errorText"
            style={{ left: `${left + (hasError("pattern") ? 100 : 0)}px` }}
          >
            (Repeated Data)
          </span>
        ) : null}
        <input
          className="formInput"
          type={type}
          maxLength={meta.maxLength ? meta.maxLength : ""}
          autoComplete="false"
          onKeyPress={(el) => inputEvent(el, meta.type || "text")}
          placeholder={`${meta.placeholder}`}
          {...handler()}
        />
      </div>
      {touched && meta.showError && (
        <InputError meta={meta} hasError={hasError} />
      )}
    </React.Fragment>
  );
};

export const ToogleInput = ({
  handler,
  touched,
  hasError,
  meta,
  valid,
  validator,
  errors,
  ...props
}) => {
  const tooltip = meta.info ? (
    <ToolTips showTooltip={true} position="right" message={meta.info}>
      <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
    </ToolTips>
  ) : null;
  const { onChange, value, disabled } = handler();
  return (
    <React.Fragment>
      {meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
          {tooltip}
        </label>
      ) : null}
      <div className="toogleInputDiv">
        <span className="text">{meta.text[0]}</span>
        <ToggleUI
          clas="noTextForm"
          changeView={(e) => onChange(!value)}
          value={value}
          disable={disabled}
          meta_id={"location"}
        />
        <span className="text">{meta.text[1]}</span>
      </div>
      {touched && <InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};

export const TextArea = ({
  handler,
  touched,
  hasError,
  meta,
  invalid,
  validator,
  errors,
  ...props
}) => (
  <React.Fragment>
    {meta.label !== "" ? (
      <label>
        {meta.label}
        {errors !== null || validator !== null ? "*" : ""}
      </label>
    ) : null}
    <textarea
      className={`formInput${touched && invalid ? " inputError" : ""}`}
      rows={meta.rows ? meta.rows : 4}
      cols={meta.cols ? meta.cols : 50}
      onKeyPress={(el) => inputEvent(el)}
      maxLength={meta.maxLength ? meta.maxLength : "400"}
      placeholder={`${meta.placeholder}`}
      {...handler()}
    />
    {touched && <InputError meta={meta} hasError={hasError} />}
    {meta.maxLength ? (
      <span className="char_limit">{meta.maxLength} character limit</span>
    ) : null}
  </React.Fragment>
);

export const CustomSelectBox = ({
  handler,
  hasError,
  meta,
  errors,
  validator,
  touched,
  invalid,
  ...props
}) => {
  const optionLists =
    meta.optionList instanceof Array ? meta.optionList : meta.optionList.value;
  const { onChange, value, disabled } = handler();
  const tooltip = meta.info ? (
    <ToolTips showTooltip={true} position="right" message={meta.info}>
      <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
    </ToolTips>
  ) : null;

  return (
    <React.Fragment>
      {meta.showLabel && meta.label !== "" ? (
        <label>
          {meta.label}
          {errors !== null || validator !== null ? "*" : ""}
          {tooltip}
        </label>
      ) : null}
      <div style={{ flexGrow: "1" }}>
        <CustomSelect
          label={meta.label}
          disabled={disabled}
          touch={touched}
          optionLists={optionLists}
          onClick={(el) => {
            onChange(el);
          }}
          {...meta}
          hasError={hasError}
          invalid={invalid}
          formValue={
            CheckValue(value) && Array.isArray(value) ? [...value] : [value]
          }
          {...handler()}
        />
      </div>
    </React.Fragment>
  );
};

export const CustomRadio = (props) => (
  <div className="checkmarkContainer">
    <label>{props.label}</label>
    <div className="checkmark_div">
      <input
        name={props.name}
        type="radio"
        value={props.value}
        onChange={() => props.change(props.value)}
      />
      <span className={`checkmark`}></span>
    </div>
  </div>
);

export const RadioUI = ({
  label,
  value,
  handler = () => null,
  disabled,
  info,
}) => (
  <div className="checkmarkContainer">
    <label>
      {label}
      {info ? (
        <ToolTips showTooltip={true} position="right" message={info}>
          <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
        </ToolTips>
      ) : null}
    </label>
    <div className="checkmark_div">
      <input type="radio" checked={value} {...handler()} disable={disabled} />
      <span className={`checkmark`}></span>
    </div>
  </div>
);

export const CheckboxUI = ({
  label,
  value,
  handler = () => null,
  disabled,
  info,
}) => (
  <div className="checkmarkContainer">
    <label>
      {label}
      {info ? (
        <ToolTips showTooltip={true} position="right" message={info}>
          <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
        </ToolTips>
      ) : null}
    </label>
    <div className="checkmark_div">
      <input
        type="checkbox"
        checked={value}
        {...handler()}
        disable={disabled}
      />
      <span className={`checkmark`}></span>
    </div>
  </div>
);

export const CheckboxUIs = ({ label, value, change, disabled, info, clas }) => (
  <div className="checkmarkContainer">
    <label>
      {label}
      {info ? (
        <ToolTips showTooltip={true} position="right" message={info}>
          <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
        </ToolTips>
      ) : null}
    </label>
    <div className="checkmark_div">
      <input
        type="checkbox"
        checked={value}
        onChange={change}
        disabled={disabled}
      />
      <span className={`checkmark ${clas || ""}`}></span>
    </div>
  </div>
);

export const CheckboxInput = ({ handler, meta }) => {
  const { value } = handler();
  return (
    <CheckboxUI
      label={meta.label}
      value={value}
      handler={handler}
      disabled="false"
      info={meta.info}
    />
  );
};

export const RadioInput = ({ handler, meta }) => {
  const { value } = handler();
  return (
    <RadioUI
      label={meta.label}
      value={value}
      handler={handler}
      disabled="false"
      info={meta.info}
    />
  );
};

export const CustomDate = (props) => {
  const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <React.Fragment>
      <div
        className={`customCalender${props.showError ? " inputError" : ""}`}
        ref={ref}
        onClick={onClick}
      >
        <SVG
          className="calenderIcon"
          src={selectIcon("calendarIcon")}
          alt="icon"
        />
        <p>{value !== null ? value : moment(new Date()).format("ll")}</p>
        {props.valid ? (
          <SVG className="tickIcon" src={selectIcon("validTick")} />
        ) : null}
      </div>
    </React.Fragment>
  ));
  return (
    <React.Fragment>
      {props.label ? <label>{props.label}</label> : null}
      <Calenders {...props} customInput={<ExampleCustomInput />} />
    </React.Fragment>
  );
};

export const CustomTime = ({
  handler,
  touched,
  meta,
  hasError,
  valid,
  invalid,
  validator,
  errors,
  ...props
}) => {
  const timerRef = React.createRef();
  const diff = 0;
  const { onChange, value } = handler();
  return (
    <React.Fragment>
      <label>
        {meta.label}
        {errors !== null || validator !== null ? "*" : ""}
      </label>
      <div className="customDatePicker">
        <TimePicker
          ref={timerRef}
          time={moment(value).format("HH:mm")}
          date={value}
          diff={diff}
          theme="Fitclub"
          className={`timepicker${invalid ? " inputError" : ""}`}
          placeholder="Start Time"
          headerColor="#F22B5D"
          onSet={(val) => {
            let current = new Date(value).setHours(val.hours, val.minute, 0, 0);
            onChange(current);
          }}
        />
        <img
          className="calenderIcon"
          src={selectIcon("time")}
          alt="icon"
          style={{ cursor: "pointer" }}
          onClick={() => {
            timerRef.current.show(true);
          }}
        />
      </div>
      {<InputError meta={meta} hasError={hasError} />}
    </React.Fragment>
  );
};

export const InputError = ({ hasError, meta }) => (
  <React.Fragment>
    {hasError("required") && (
      <span className="error">{`${
        meta.label.length ? meta.label + " is " : ""
      }required`}</span>
    )}
    {hasError("minLength") && (
      <span className="error">{`min length should be ${meta.minLength}`}</span>
    )}
    {hasError("maxLength") && (
      <span className="error">{`max length should be ${meta.maxLength}`}</span>
    )}
    {hasError("pattern") && (
      <span className="error">{`Invalid ${meta.label}`}</span>
    )}
    {hasError("invalidEmail") && (
      <span className="error">{`${errorHandler("invalidEmail")}`}</span>
    )}
    {hasError("maxDate") && (
      <span className="error">{`${errorHandler("maxDate")}`}</span>
    )}
    {hasError("invalid") && <span className="error">{`Invalid`}</span>}
    {hasError("wrongPassword") && (
      <span className="error">{`${errorHandler("wrongPassword")}`}</span>
    )}
    {hasError("matchingPassword") && (
      <span className="error">{`${errorHandler("matchingPassword")}`}</span>
    )}
    {hasError("wrongMemberShipcode") && (
      <span className="error">{`${errorHandler("wrongMemberShipcode")}`}</span>
    )}
    {hasError("alreadyMemberShipcode") && (
      <span className="error">{`${errorHandler(
        "alreadyMemberShipcode"
      )}`}</span>
    )}
    {hasError("alreadyEmail") && (
      <span className="error">{`${errorHandler("alreadyEmail")}`}</span>
    )}
    {hasError("timeError") && (
      <span className="error">{`${errorHandler(
        `timeError${meta.add ? "" : "Edit"}`
      )}`}</span>
    )}
  </React.Fragment>
);

export const InputError1 = ({ hasError, meta, display }) => (
  <span className="error" style={{ display: display ? "" : "none" }}>
    {hasError("required")
      ? `${meta.label.length ? meta.label + " is " : ""}required`
      : null}
    {hasError("minLength") ? `min length should be ${meta.minLength}` : null}
    {hasError("maxLength") ? `max length should be ${meta.maxLength}` : null}
    {hasError("pattern") ? `Invalid ${meta.label}` : null}
    {hasError("invalidEmail") ? `${errorHandler("invalidEmail")}` : null}
    {hasError("maxDate") ? `${errorHandler("maxDate")}` : null}
    {hasError("invalid") ? `Invalid` : null}
    {hasError("wrongPassword") ? `${errorHandler("wrongPassword")}` : null}
    {hasError("wrongMemberShipcode")
      ? `${errorHandler("wrongMemberShipcode")}`
      : null}
    {hasError("alreadyMemberShipcode")
      ? `${errorHandler("alreadyMemberShipcode")}`
      : null}
    {hasError("alreadyEmail") ? `${errorHandler("alreadyEmail")}` : null}
  </span>
);

InputError1.propTypes = {
  display: PropTypes.bool.isRequired,
};

InputError1.defaultProps = {
  display: true,
};
